import { BfnStatus } from '@/models/Befehlsnachricht'

export default class BefehlsnachrichtVisuellerStatusMatchError extends Error {
  public visuellerStatus: string

  public status: BfnStatus

  constructor(visuellerStatus: string, status: BfnStatus) {
    super(
      `Statusprüfung: der visuelle Status "${visuellerStatus}" entspricht nicht dem Status "${status}".`
    )
    this.visuellerStatus = visuellerStatus
    this.status = status
    this.name = 'BefehlsnachrichtVisuellerStatusMatchError'
  }
}
